import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, share } from 'rxjs';
import { App } from '../models/app.model';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  getApps$?: Observable<App>;

  constructor(
    private httpClient: HttpClient
  ) { }

  getApps(): Observable<App> {
    if (!this.getApps$) {
      this.getApps$ = this.httpClient.get<App>(environment.apiUrl + '/apps').pipe(share());
    }
    return this.getApps$
  }
}
